import VisionProductCard from './VisionProductCard'

export default VisionProductCard
